import React, { useEffect, useState } from "react";
import { FiHome, FiPackage, FiBell, FiUser, FiSearch } from "react-icons/fi";

export default function LogisticViewDeliveryOrders() {
  const [deliveries, setDeliveries] = useState({
    preparing: [],
    delivering: [],
    delivered: [],
  });

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('preparing');

  // Simulated API call (replace with real backend)
  useEffect(() => {
    const fetchDeliveries = async () => {
      try {
        const data = {
          preparing: [
            { id: 1, group: "#123459", products: 4, amount: 3200, time: "03:29:00" },
            { id: 2, group: "#123460", products: 2, amount: 1800, time: "02:10:00" },
          ],
          delivering: [
            { id: 3, group: "#123461", products: 6, amount: 5000, time: "01:00:00" },
          ],
          delivered: [],
        };

        setTimeout(() => {
          setDeliveries(data);
          setLoading(false);
        }, 1000);
      } catch (error) {
        console.error("Error fetching deliveries:", error);
        setLoading(false);
      }
    };

    fetchDeliveries();
  }, []);

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">

      {/* Header */}
      <div className="bg-[#F1F3F2] px-5 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-black">Deliveries</h1>
        <FiSearch size={24} />
      </div>

      {/* Tabs */}
      <div className="bg-[#F1F3F2] px-5 pb-4 flex gap-2">
        <button
          onClick={() => setActiveTab('preparing')}
          className={`text-black text-sm px-3 py-1.5 rounded-md w-fit whitespace-nowrap border ${
            activeTab === 'preparing' ? 'bg-[#19C463] border-[#19C463]' : 'bg-white border-black'
          }`}
        >
          Preparing to Pickup
        </button>
        <button
          onClick={() => setActiveTab('delivering')}
          className={`text-black text-sm px-3 py-1.5 rounded-md w-fit whitespace-nowrap border ${
            activeTab === 'delivering' ? 'bg-[#19C463] border-[#19C463]' : 'bg-white border-black'
          }`}
        >
          Delivering
        </button>
        <button
          onClick={() => setActiveTab('delivered')}
          className={`text-black text-sm px-3 py-1.5 rounded-md w-fit whitespace-nowrap border ${
            activeTab === 'delivered' ? 'bg-[#19C463] border-[#19C463]' : 'bg-white border-black'
          }`}
        >
          Delivered
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 bg-[#F1F3F2] px-5 pb-24 overflow-y-auto">

        {/* Loading */}
        {loading && (
          <p className="text-center text-gray-500 mt-10">Loading deliveries...</p>
        )}

        {/* Preparing Section */}
        {!loading && (
          <>
            <div className="flex items-center gap-3 mb-3">
              <div className="flex-1 h-px bg-black"></div>
              <span className="text-sm font-bold text-black">Preparing to Pickup</span>
              <div className="flex-1 h-px bg-black"></div>
            </div>

            {deliveries.preparing.length === 0 ? (
              <p className="text-center text-gray-400 mb-4">No preparing deliveries</p>
            ) : (
              deliveries.preparing.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 mb-3 shadow-sm">
                  <h3 className="text-base font-bold text-black mb-1">{item.group}</h3>
                  <p className="text-sm text-black mb-1">Product: {item.products}</p>

                  <div className="flex justify-between items-start mb-1">
                    <p className="text-sm text-black">Status: Preparing</p>
                    <p className="text-lg font-bold text-black">?{item.amount}</p>
                  </div>

                  <p className="text-sm text-[#19C463] font-medium">
                    Time left: {item.time}
                  </p>
                </div>
              ))
            )}

            {/* Delivering Section */}
            <div className="flex items-center gap-3 mb-3 mt-4">
              <div className="flex-1 h-px bg-black"></div>
              <span className="text-sm font-bold text-black">Delivering</span>
              <div className="flex-1 h-px bg-black"></div>
            </div>

            {deliveries.delivering.length === 0 ? (
              <p className="text-center text-gray-400 mb-4">No deliveries in progress</p>
            ) : (
              deliveries.delivering.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 mb-3 shadow-sm">
                  <h3 className="text-base font-bold text-black mb-1">{item.group}</h3>
                  <p className="text-sm text-black mb-1">Product: {item.products}</p>

                  <div className="flex justify-between items-start mb-1">
                    <p className="text-sm text-black">Status: Delivering</p>
                    <p className="text-lg font-bold text-black">?{item.amount}</p>
                  </div>

                  <p className="text-sm text-[#19C463] font-medium">
                    Time left: {item.time}
                  </p>
                </div>
              ))
            )}

            {/* Delivered Section */}
            <div className="flex items-center gap-3 mb-3 mt-4">
              <div className="flex-1 h-px bg-black"></div>
              <span className="text-sm font-bold text-black">Delivered</span>
              <div className="flex-1 h-px bg-black"></div>
            </div>

            {deliveries.delivered.length === 0 ? (
              <p className="text-center text-gray-400 mb-4">No completed deliveries</p>
            ) : (
              deliveries.delivered.map((item) => (
                <div key={item.id} className="bg-white rounded-lg p-4 mb-3 shadow-sm">
                  <h3 className="text-base font-bold text-black mb-1">{item.group}</h3>
                  <p className="text-sm text-black mb-1">Product: {item.products}</p>

                  <div className="flex justify-between items-start mb-1">
                    <p className="text-sm text-black">Status: Delivered</p>
                    <p className="text-lg font-bold text-black">?{item.amount}</p>
                  </div>
                </div>
              ))
            )}
          </>
        )}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-200 flex justify-around items-center py-2 pb-4 px-2">
        <div className="flex flex-col items-center gap-1">
          <FiHome size={24} color="#19C463" />
          <span className="text-xs text-[#19C463] font-bold">Home</span>
        </div>

        <div className="flex flex-col items-center gap-1">
          <FiPackage size={24} />
          <span className="text-xs text-black">Deliveries</span>
        </div>

        <div className="flex flex-col items-center gap-1">
          <FiBell size={24} />
          <span className="text-xs text-black">Notification</span>
        </div>

        <div className="flex flex-col items-center gap-1 relative">
          <FiUser size={24} />
          <span className="text-xs text-black">Profile</span>
        </div>
      </div>
    </div>
  );
}
